module.exports = __webpack_public_path__ + "images/disc2c36a4.png";


//////////////////
// WEBPACK FOOTER
// ./cms/client/images/radio/disc.png
// module id = 59
// module chunks = 4